import React from 'react'
import { CheckCircle } from 'lucide-react'
import { useRevealOnScroll } from '../../hooks/useRevealOnScroll'

// Fonte: public/landing/editor-screenshot.png (1440x900, conta de demonstração
// com dados fictícios). Para atualizar: nova captura + `npm run optimize:landing`.
const IMG = {
  base: '/landing/editor/editor-preview',
  alt: 'Tela do editor de avaliações: banco de questões com filtros à esquerda e a prova sendo montada à direita, com quatro questões adicionadas.',
}

const CHECKLIST = [
  'Adicione questões do banco direto na prova',
  'Reordene e edite o enunciado antes de imprimir',
  'Cabeçalho com escola, turma, data e campo de nota',
  'Gabarito gerado junto com o PDF',
]

const EditorPreviewSection: React.FC = () => {
  const revealRef = useRevealOnScroll<HTMLDivElement>()

  return (
    <section
      id="montagem"
      className="py-20 bg-cream-100 dark:bg-ink-700"
      aria-labelledby="montagem-titulo"
    >
      <div ref={revealRef} className="container mx-auto px-4">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-12 items-center max-w-6xl mx-auto">
          <div data-reveal-item>
            <p className="flex items-center gap-3 font-mono text-caderno-xs uppercase tracking-widest text-ink-400 dark:text-ink-300 mb-4">
              <span className="text-terra-500">05</span>
              <span aria-hidden="true" className="w-8 h-px bg-cream-400 dark:bg-ink-500" />
              Da seleção ao PDF
            </p>
            <h2
              id="montagem-titulo"
              className="text-3xl md:text-4xl font-display text-ink-900 dark:text-cream-50 mb-4"
            >
              A etapa seguinte:{' '}
              <span className="italic font-normal text-terra-500">montar e imprimir</span>.
            </h2>
            <p className="text-lg text-ink-500 dark:text-cream-300 mb-8">
              O resto acontece aqui: o banco de um lado, sua prova tomando forma do outro. Nada de
              alternar entre quatro abas.
            </p>
            <ul className="space-y-3 list-none p-0">
              {CHECKLIST.map((item) => (
                <li key={item} className="flex items-start text-ink-700 dark:text-cream-200">
                  <CheckCircle className="w-5 h-5 text-moss-500 mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div data-reveal-item className="reveal-delay-1 relative">
            <span
              aria-hidden="true"
              className="absolute -top-9 left-8 hidden md:block font-hand text-xl text-terra-500 -rotate-3"
            >
              cada questão entra com um clique →
            </span>
            <div className="bg-surface dark:bg-ink-900 border border-cream-400 dark:border-ink-500 rounded-caderno-sm shadow-caderno-xl overflow-hidden">
              <div className="flex items-center gap-2 px-4 py-2.5 border-b border-cream-300 dark:border-ink-500">
                <span className="w-2.5 h-2.5 rounded-full bg-terra-300" aria-hidden="true" />
                <span className="w-2.5 h-2.5 rounded-full bg-ochre-300" aria-hidden="true" />
                <span className="w-2.5 h-2.5 rounded-full bg-moss-300" aria-hidden="true" />
                <span className="ml-2 font-mono text-caderno-xs text-ink-400 dark:text-ink-300 bg-cream-100 dark:bg-ink-700 rounded-full px-3 py-0.5">
                  atividadepronta.com.br/editor
                </span>
              </div>
              <picture>
                <source
                  type="image/avif"
                  srcSet={`${IMG.base}-640.avif 640w, ${IMG.base}-960.avif 960w, ${IMG.base}-1280.avif 1280w`}
                  sizes="(min-width: 1024px) 52vw, 92vw"
                />
                <source
                  type="image/webp"
                  srcSet={`${IMG.base}-640.webp 640w, ${IMG.base}-960.webp 960w, ${IMG.base}-1280.webp 1280w`}
                  sizes="(min-width: 1024px) 52vw, 92vw"
                />
                <img
                  src={`${IMG.base}-960.webp`}
                  width={1440}
                  height={900}
                  alt={IMG.alt}
                  className="block w-full h-auto"
                  loading="lazy"
                  decoding="async"
                />
              </picture>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default EditorPreviewSection
